/* cs-forms.js (CS v29, 23 Oct 2026, audit LEAD-09)
   The quote form on /pages/contact-us lives in the page content in three languages.
   Its "Enquiry type" and "Message" fields were required even when the buyer had already
   picked a product, a quantity and a country. This makes both optional; the form's own
   script still fills the routing (triage when no type is chosen) and appends the enquiry
   details to the message, so the email the team receives is never empty.
   If this file fails to load, the form keeps working as before (fields stay required). */
(function () {
  function ready(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }
  ready(function () {
    ['cs-eq-intent', 'cs-eq-message'].forEach(function (id) {
      var el = document.getElementById(id);
      if (!el) return;
      el.removeAttribute('required');
      el.setAttribute('aria-required', 'false');
      var label = document.querySelector('label[for="' + id + '"]');
      if (label) label.classList.add('cs-eq-optional');
    });
  });
})();
